import { render, staticRenderFns } from "./ProjectedChart.vue?vue&type=template&id=72c20956&scoped=true&"
import script from "./ProjectedChart.vue?vue&type=script&lang=js&"
export * from "./ProjectedChart.vue?vue&type=script&lang=js&"
import style0 from "./ProjectedChart.vue?vue&type=style&index=0&id=72c20956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c20956",
  null
  
)

export default component.exports